import * as React from "react";
import Accordion, { AccordionSlots } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
import { ScreeningsData } from "../../types/dataTypes.ts";
import { Box, styled } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme } from "@mui/material/styles";
import { ScreeningsForOneDate } from "./ScreeningsForOneDate.tsx";

interface ScreeningsAccordionProps {
  screeningsByDate: ScreeningsData[];
  filmTitle: string;
  optimise: boolean;
}

const StyledFade = styled(Fade, {
  shouldForwardProp: (prop) => prop !== "ownerState",
})({});

export const ScreeningsAccordion: React.FC<ScreeningsAccordionProps> = ({
  screeningsByDate,
  filmTitle,
  optimise,
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const theme = useTheme();

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const transitionObject = () => {
    const obj: any = { timeout: 400 };
    if (optimise) {
      obj.mountOnEnter = true;
      obj.unmountOnExit = true;
    }
    return obj;
  };

  return (
    <Accordion
      expanded={expanded}
      slots={{ transition: StyledFade as AccordionSlots["transition"] }}
      slotProps={{
        transition: transitionObject(),
      }}
      sx={{
        backgroundColor: theme.palette.background.default,
        "& .MuiAccordion-region": { height: expanded ? "auto" : 0 },
        "& .MuiAccordionDetails-root": {
          display: expanded ? "block" : "none",
        },
        "& .MuiAccordionSummary-root:hover, .MuiButtonBase-root:hover": {
          cursor: "default",
        },
        "&.Mui-focused": {
          backgroundColor: theme.palette.background.default,
        },
        marginTop: 0.5,
        boxShadow: "none",
      }}
    >
      <AccordionSummary
        aria-controls="panel1-content"
        id="panel1-header"
        // expandIcon={<ExpandMoreIcon />}
        sx={{
          padding: "0px",
          backgroundColor: theme.palette.background.paper,
          cursor: "default",
        }}
      >
        {expanded ? (
          <ExpandLessIcon
            sx={{ color: theme.palette.primary.main }}
            onClick={handleExpansion}
          />
        ) : (
          <ExpandMoreIcon
            sx={{ color: theme.palette.primary.main }}
            onClick={handleExpansion}
          />
        )}
        <Typography
          sx={{
            color: theme.palette.text.primary,
            "&:hover": {
              // backgroundColor: "#f5f5f5", // Change to the desired hover background color
              color: "#FFFFFF",
            },
            cursor: "pointer",
          }}
          onClick={handleExpansion}
        >
          {" "}
          {expanded ? "HIDE SHOWTIMES" : "VIEW SHOWTIMES"}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          backgroundColor: theme.palette.background.paper,
          margin: "0px",
          padding: "0px",
        }}
        // onClick={handleAccordionDetailsClick}
      >
        {screeningsByDate.map(({ screenings_date_label, screenings }) => (
          <Box
            sx={{
              fontSize: "large",
              marginBottom: 2,
              marginLeft: 0,
              marginRight: 0,
            }}
            key={`${filmTitle}-${screenings_date_label}`}
          >
            <Typography
              sx={{
                fontSize: "large",
                fontWeight: "bold",
                //   screenings_date_label === "TODAY" ||
                //   screenings_date_label === "TOMORROW"
                //     ? "bold"
                //     : "normal",
              }}
            >
              {screenings_date_label}
            </Typography>

            <ScreeningsForOneDate
              screenings={screenings}
              filmTitle={filmTitle}
            />
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
